(function () {
  function getPhoneWithDialcodeMessages() {
    var rawLocale = String(
      (window.Shopify && window.Shopify.locale) ||
      (document.documentElement && document.documentElement.lang) ||
      'en'
    ).trim().toLowerCase();
    var localeBase = rawLocale.split('-')[0];
    var isEnglishLocale = rawLocale === 'en' || localeBase === 'en';
    var fallbackMessages = {
      fieldRequired: 'Please fill in this information.',
      areaCodeNeeded: 'Area code needed',
      phoneNumberNeeded: 'Phone number needed',
      invalidPhoneNumber: 'Please enter a correct phone number'
    };
    var messagesByLocale = {
      'zh-cn': {
        fieldRequired: '请填写此信息。',
        areaCodeNeeded: '请选择区号',
        phoneNumberNeeded: '请输入电话号码',
        invalidPhoneNumber: '请输入正确的电话号码'
      },
      'zh-tw': {
        fieldRequired: '請填寫此資訊。',
        areaCodeNeeded: '請選擇區號',
        phoneNumberNeeded: '請輸入電話號碼',
        invalidPhoneNumber: '請輸入正確的電話號碼'
      },
      de: {
        fieldRequired: 'Bitte fülle diese Information aus.',
        areaCodeNeeded: 'Vorwahl erforderlich',
        phoneNumberNeeded: 'Telefonnummer erforderlich',
        invalidPhoneNumber: 'Bitte gib eine korrekte Telefonnummer ein'
      },
      fr: {
        fieldRequired: 'Veuillez renseigner cette information.',
        areaCodeNeeded: 'Indicatif requis',
        phoneNumberNeeded: 'Numéro de téléphone requis',
        invalidPhoneNumber: 'Veuillez saisir un numéro de téléphone correct'
      },
      es: {
        fieldRequired: 'Por favor completa esta información.',
        areaCodeNeeded: 'Se requiere el código de área',
        phoneNumberNeeded: 'Se requiere el número de teléfono',
        invalidPhoneNumber: 'Por favor ingresa un número de teléfono correcto'
      },
      it: {
        fieldRequired: 'Inserisci queste informazioni.',
        areaCodeNeeded: 'Prefisso richiesto',
        phoneNumberNeeded: 'Numero di telefono richiesto',
        invalidPhoneNumber: 'Inserisci un numero di telefono corretto'
      },
      nl: {
        fieldRequired: 'Vul deze informatie in.',
        areaCodeNeeded: 'Netnummer vereist',
        phoneNumberNeeded: 'Telefoonnummer vereist',
        invalidPhoneNumber: 'Voer een correct telefoonnummer in'
      }
    };
    var localizedMessages = messagesByLocale[rawLocale] || messagesByLocale[localeBase] || {};
    var globalMessages = window.frontendMessages || {};
    var resolvedMessages = {};

    Object.keys(fallbackMessages).forEach(function (key) {
      var fallbackValue = fallbackMessages[key];
      var globalValue = typeof globalMessages[key] === 'string' ? globalMessages[key] : '';
      if (!isEnglishLocale && localizedMessages[key] && (!globalValue || globalValue === fallbackValue)) {
        resolvedMessages[key] = localizedMessages[key];
        return;
      }
      resolvedMessages[key] = globalValue || localizedMessages[key] || fallbackValue;
    });

    return resolvedMessages;
  }

  var messages = getPhoneWithDialcodeMessages();
  /**
   * 获取当前组合组件中的区号容器和手机号输入框
   */
  function getDialcodeAndPhoneElements(group) {
    if (!group) return { dialcodeContainer: null, phoneInput: null };

    // 区号容器：使用已有的 component-dialcode-selector 组件
    var dialcodeContainer = group.querySelector('[data-component="dialcode-selector"]');

    // 手机号输入：优先通过 component-text-input 结构查找
    var textInputWrapper = group.querySelector('.setup-phone-page__phone-input-field.component-text-input')
      || group.querySelector('.component-text-input.setup-phone-page__phone-input-field')
      || group.querySelector('.setup-phone-page__phone-input-field .component-text-input')
      || group.querySelector('.setup-phone-page__phone-input-field');

    var phoneInput = null;
    if (textInputWrapper) {
      phoneInput = textInputWrapper.querySelector('.component-text-input__field') || textInputWrapper.querySelector('input[type="tel"]');
    } else {
      phoneInput = group.querySelector('input[name="phoneNumber"]') || group.querySelector('input[type="tel"]');
    }

    return {
      dialcodeContainer: dialcodeContainer,
      phoneInput: phoneInput
    };
  }

function showDialcodeError(dialcodeContainer, message) {
  if (!dialcodeContainer) return;
  dialcodeContainer.classList.add('component-dialcode-selector--error');
  const errorElement = dialcodeContainer.querySelector('.component-dialcode-selector__error');
  if (errorElement) {
    errorElement.textContent = message || messages.areaCodeNeeded;
    errorElement.style.display = 'flex';
  }
}

function clearDialcodeError(dialcodeContainer) {
  if (!dialcodeContainer) return;
  dialcodeContainer.classList.remove('component-dialcode-selector--error');
  const errorElement = dialcodeContainer.querySelector('.component-dialcode-selector__error');
  if (errorElement) {
    errorElement.textContent = '';
    errorElement.style.display = 'none';
  }
}

  function showPhoneError(phoneInput, message) {
    if (!phoneInput) return;
    if (window.TextInputComponent && typeof window.TextInputComponent.setError === 'function') {
      window.TextInputComponent.setError(phoneInput, message);
    } else {
      // 简单兜底：直接设置 title，避免完全没提示
      phoneInput.title = message;
    }
  }

  function clearPhoneError(phoneInput) {
    if (!phoneInput) return;
    if (window.TextInputComponent && typeof window.TextInputComponent.clearError === 'function') {
      window.TextInputComponent.clearError(phoneInput);
    } else {
      phoneInput.removeAttribute('title');
    }
  }

  /**
   * 针对单个组合组件做校验
   * 规则：
   *  - 若整体必填（data-optional="false"）：
   *      - 区号和手机号必须成对出现，不能只填一个或都不填
   *  - 若整体选填（data-optional="true"）：
   *      - 两个都不填：通过
   *      - 只填一个：错误
   *  - 区号和手机号都填时：
   *      - 使用 DialCodeSelector + libphonenumber-js 校验格式
   *      - 若不可用则退回到数字长度 7~15 的兜底校验
   */
  function validateDialcodeAndPhone(group, options) {
    if (!group) return true;

    var optionalFlag = group.getAttribute('data-optional');
    var isOptional = optionalFlag === 'true';

    var elements = getDialcodeAndPhoneElements(group);
    var dialcodeContainer = elements.dialcodeContainer;
    var phoneInput = elements.phoneInput;

    if (!phoneInput || !dialcodeContainer) {
      return true;
    }

    clearDialcodeError(dialcodeContainer);

    var rawPhone = (phoneInput.value || '').trim();
    var hiddenDialInput = dialcodeContainer.querySelector('input[type="hidden"]');
    var dialValue = hiddenDialInput ? (hiddenDialInput.value || '').trim() : '';

    // 情况 1：两个都空
    if (!rawPhone && !dialValue) {
      if (isOptional) {
        clearPhoneError(phoneInput);
        return true;
      }
      
      // 默认显示错误（submit时 options 为 undefined），或者由 options 指定（blur时）
      // 注意：suppressEmptyError 变量名在这里其实是反向使用的（true 表示显示），保持兼容性
      var shouldShowError = options === undefined || options.suppressEmptyError;
      
      if (shouldShowError) {
        showPhoneError(phoneInput, messages.fieldRequired);
        showDialcodeError(dialcodeContainer, messages.fieldRequired);
      }
      return false;
    }

    // 情况 2：只选区号，没填手机号
    if (!rawPhone && dialValue) {
      // 手机号缺失
      showPhoneError(phoneInput, messages.phoneNumberNeeded);
      return false;
    }

    // 情况 3：只填手机号，没选区号
    if (rawPhone && !dialValue) {
      // 区号缺失
      showDialcodeError(dialcodeContainer, messages.areaCodeNeeded);
      return false;
    }
    
    // 情况 4：两者都填了，做格式校验
    // 优先使用 DialCodeSelector + libphonenumber-js
    if (window.DialCodeSelector && typeof window.DialCodeSelector.validatePhoneNumber === 'function') {
      var result = window.DialCodeSelector.validatePhoneNumber(dialcodeContainer, rawPhone);
      if (!result || !result.isValid) {
        showPhoneError(phoneInput, messages.invalidPhoneNumber);
        return false;
      }
    } else {
      // 兜底：简单数字长度校验
      var digits = rawPhone.replace(/\D/g, '');
      if (digits.length < 7 || digits.length > 15) {
        showPhoneError(phoneInput, messages.invalidPhoneNumber);
        return false;
      }
    }

    clearPhoneError(phoneInput);
    clearDialcodeError(dialcodeContainer);
    return true;
  }

  function attachEventsForGroup(group) {
    var elements = getDialcodeAndPhoneElements(group);
    var dialcodeContainer = elements.dialcodeContainer;
    var phoneInput = elements.phoneInput;

    if (!phoneInput || !dialcodeContainer) {
      return;
    }

    var hasPhoneInputInteraction = false;

    // 手机号失焦时做一次校验
    phoneInput.addEventListener('blur', function (e) {
      // 检查是否点击了清除按钮，如果是则跳过校验（避免清除后立即重新设置错误）
      const relatedTarget = e.relatedTarget;
      const isClickingClearBtn = relatedTarget && relatedTarget.closest('.component-text-input__clear-btn');
      if (isClickingClearBtn) {
        return; // 不处理失焦逻辑
      }
      validateDialcodeAndPhone(group, { suppressEmptyError: hasPhoneInputInteraction });
    });

    // 区号改变时，如果已经填了手机号，也重新校验一次
    dialcodeContainer.addEventListener('countryChanged', function () {
      clearDialcodeError(dialcodeContainer);
      if ((phoneInput.value || '').trim()) {
        validateDialcodeAndPhone(group);
      }
    });

    phoneInput.addEventListener('input', function () {
      hasPhoneInputInteraction = true;
    });

    // 监听来自 component-text-input 的清除事件，确保点击 clear 按钮时能正确清空内容和错误状态
    phoneInput.addEventListener('input:clear', function () {
      // 标记为尚未有有效输入交互，避免立刻触发「必填」错误
      hasPhoneInputInteraction = false;
      clearPhoneError(phoneInput);
      clearDialcodeError(dialcodeContainer);
    });

    // 兜底：直接监听清除按钮点击，处理因失焦顺序导致的残留错误
    var inputContainer = phoneInput.closest('.component-text-input');
    if (inputContainer) {
      var clearBtn = inputContainer.querySelector('.component-text-input__clear-btn');
      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          // 等 text-input 自己清空 value 之后，再清一次错误状态
          setTimeout(function () {
            hasPhoneInputInteraction = false;
            clearPhoneError(phoneInput);
            clearDialcodeError(dialcodeContainer);
          }, 0);
        });
      }
    }

    // 表单提交时统一校验
    var form = group.closest('form');
    if (form) {
      form.addEventListener('submit', function (event) {
        var ok = validateDialcodeAndPhone(group);
        if (!ok) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    }
  }

  function initAllPhoneWithDialcode() {
    var groups = document.querySelectorAll('[data-component="phone-with-dialcode"]');
    if (!groups || !groups.length) return;

    groups.forEach(function (group) {
      if (group.getAttribute('data-initialized') === 'true') return;
      group.setAttribute('data-initialized', 'true');
      attachEventsForGroup(group);
    });
  }

  // 对外暴露一个全局对象，便于后续调试或手动触发
  window.PhoneWithDialcode = {
    init: initAllPhoneWithDialcode,
    validate: validateDialcodeAndPhone
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllPhoneWithDialcode);
  } else {
    initAllPhoneWithDialcode();
  }
})();


